import "/__w/1/s/BotFramework-WebChat/packages/fluent-theme/src/components/activityStatus/VoiceTranscriptActivityStatus.module_built.css";
const classes = {"voice-transcript-activity-status":"wC5zPBW_voice-transcript-activity-status","voice-transcript-activity-status__divider":"wC5zPBW_voice-transcript-activity-status__divider","voice-transcript-activity-status__agent-label":"wC5zPBW_voice-transcript-activity-status__agent-label"}
export default classes

const _voice_transcript_activity_status0 = classes["voice-transcript-activity-status"]
export { _voice_transcript_activity_status0 as "voice-transcript-activity-status" }

const _voice_transcript_activity_status__divider0 = classes["voice-transcript-activity-status__divider"]
export { _voice_transcript_activity_status__divider0 as "voice-transcript-activity-status__divider" }

const _voice_transcript_activity_status__agent_label0 = classes["voice-transcript-activity-status__agent-label"]
export { _voice_transcript_activity_status__agent_label0 as "voice-transcript-activity-status__agent-label" }
